<template>
  <canvas :id="id" width="100" height="60"></canvas>
</template>

<script>
    import Chart from './chart'
    import {v4 as uuidv4} from 'uuid'

    export default {
        components: {},
        name: 'LineChart',
        props: {
            title: {
                type: String,
                required: true
            },
            graphData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                id: '',
                chartData: {
                    type: 'line',
                    data: this.graphData,
                    options: {
                        responsive: true,
                        hoverMode: 'index',
                        stacked: false,
                        title: {
                            display: false,
                            text: this.title
                        }
                    }
                },
                chart: null
            }
        },
        watch: {
            graphData(value) {
                if (this.chart) {
                    this.updateChart(this.chart, value)
                }
            }
        },
        computed: {},
        methods: {
            createChart(chartId, chartData) {
                const ctx = document.getElementById(chartId)
                const myChart = new Chart(ctx, {
                    type: chartData.type,
                    data: chartData.data,
                    options: chartData.options,
                })
                return myChart
            },
            updateChart(chart, chartData) {
                chart.data.labels = chartData.labels
                chart.data.datasets = chartData.datasets
                chart.update()
            }
        },
        mounted() {
            this.id = uuidv4()
            this.$nextTick(() => {
                this.chart = this.createChart(this.id, this.chartData)
            })
        }
    }
</script>